import {SearchInputFormDefaultBox} from "./search-input-form.default.box";

export const SearchInputFormBox  = SearchInputFormDefaultBox;